import * as React from 'react';
import { toast } from 'react-toastify';
import { ToastComponent, ToastType, ToastOptions } from '@common/components';

import { actions } from 'react-redux-form';
import { Action, Dispatch } from 'redux';

import { PropertyManagerState } from './property-manager.reducer';
import { propertyManagementService } from '@services/PropertyManagementService';
import { PropertyManagerViewModel, PropertyManagerSearchViewModel } from '@models/PropertyManager';
import { AppState, history } from '..';
import { OptionsViewModel, PageViewModel } from '@models/common.models';
import { contractService } from '@services/ContractService';
import { ContractSimpleViewModel } from '@models/Contract';
import FormNames from '../_constants/FormNames.enum';
import { RouteDefinitions, getRoute } from '@common/route-definitions';

export enum PropertyManagerActionType {
  /********** Create **********/
  CreatePropertyManagerStart = 'CreatePropertyManagerStart',
  CreatePropertyManagerSuccess = 'CreatePropertyManagerSuccess',
  CreatePropertyManagerFailure = 'CreatePropertyManagerFailure',

  /********** Edit **********/
  EditPropertyManagerStart = 'EditPropertyManagerStart',
  EditPropertyManagerSuccess = 'EditPropertyManagerSuccess',
  EditPropertyManagerFailure = 'EditPropertyManagerFailure',

  /********** Get **********/
  GetPropertyManagerStart = 'GetPropertyManagerStart',
  GetPropertyManagerSuccess = 'GetPropertyManagerSuccess',
  GetPropertyManagerFailure = 'GetPropertyManagerFailure',

  /********** Get Details**********/
  GetPropertyManagerDetailStart = 'GetEscrowOfficerDetailStart',
  GetPropertyManagerDetailSuccess = 'GetEscrowOfficerDetailSuccess',
  GetPropertyManagerDetailFailure = 'GetEscrowOfficeDetailFailure',

  /********** Get PM Type **********/
  GetPropertyManagerTypesStart = 'GetPropertyManagerTypesStart',
  GetPropertyManagerTypesSuccess = 'GetPropertyManagerTypesSuccess',
  GetPropertyManagerTypesFailure = 'GetPropertyManagerTypesFailure',

  /********** Get PM Status **********/
  GetPropertyManagerStatusesStart = 'GetPropertyManagerStatusesStart',
  GetPropertyManagerStatusesSuccess = 'GetPropertyManagerStatusesSuccess',
  GetPropertyManagerStatusesFailure = 'GetPropertyManagerStatusesFailure',

  /********** Get Contract Via PM **********/
  GetPropertyManagerContractsStart = 'GetPropertyManagerContractsStart',
  GetPropertyManagerContractsSuccess = 'GetPropertyManagerContractsSuccess',
  GetPropertyManagerContractsFailure = 'GetPropertyManagerContractsFailure',

  /********** Search For A PM **********/
  SearchPropertyManagerStart = 'SearchPropertyManagerStart',
  SearchPropertyManagerSuccess = 'SearchPropertyManagerSuccess',
  SearchPropertyManagerFailure = 'SearchPropertyManagerFailure'

  // PropertyManagerToggleViewOnly = 'PropertyManagerToggleViewOnly',

  // PropertyManagerSetOfficeAction = 'PropertyManagerSetOfficeAction',
}

// This is defining the action definition for certain actions on the page.
// There may be multiple types of these on a given page.
// All properties should be readonly.

/********** Create & Edit **********/
export interface PropertyManagerAction extends Action {
  readonly type: PropertyManagerActionType;
  readonly errorMessage?: string;
  readonly createdID?: number;
  readonly loadingPropertyManagerId?: number;
}

/********** Get **********/
export interface GetPropertyManagerTypesStartAction extends Action {
  readonly type: PropertyManagerActionType.GetPropertyManagerTypesStart;
  readonly message: string;
}
export interface GetPropertyManagerSuccessAction extends Action {
  readonly type: PropertyManagerActionType.GetPropertyManagerSuccess;
  readonly message?: string;
  readonly loadedPropertyManager: PropertyManagerViewModel;
  // readonly viewOnlypropertyManagementOffice?: PropertyManagementOfficeViewModel;
}

/********* Get Details**************/
export interface GetPropertyManagerDetailStartAction extends Action {
  readonly statusMessage: string;
  readonly type: PropertyManagerActionType.GetPropertyManagerDetailStart;
}
export interface GetPropertyManagerDetailSuccessAction extends Action {
  readonly statusMessage: string;
  readonly propertyManagerVM: PropertyManagerViewModel;
  readonly type: PropertyManagerActionType.GetPropertyManagerDetailSuccess;
}
export interface GetPropertyManagerDetailFailureAction extends Action {
  readonly statusMessage: string;
  readonly errorMessage: string;
  readonly type: PropertyManagerActionType.GetPropertyManagerDetailFailure;
}

/********** Get PM Type **********/
export interface GetPropertyManagerTypesSuccessAction extends Action {
  readonly type: PropertyManagerActionType.GetPropertyManagerTypesSuccess;
  readonly message: string;
  readonly propertyManagerTypes: Array<OptionsViewModel>;
}
export interface GetPropertyManagerTypesFailureAction extends Action {
  readonly type: PropertyManagerActionType.GetPropertyManagerTypesFailure;
  readonly errorMessage: string;
}

/********** Get PM Status **********/
export interface GetPropertyManagerStatusesStartAction extends Action {
  readonly type: PropertyManagerActionType.GetPropertyManagerStatusesStart;
  readonly message: string;
}
export interface GetPropertyManagerStatusesSuccessAction extends Action {
  readonly type: PropertyManagerActionType.GetPropertyManagerStatusesSuccess;
  readonly message: string;
  readonly propertyManagerStatuses: Array<OptionsViewModel>;
}
export interface GetPropertyManagerStatusesFailureAction extends Action {
  readonly type: PropertyManagerActionType.GetPropertyManagerStatusesFailure;
  readonly errorMessage: string;
}

/********** Get Contract Via PM **********/
export interface GetPropertyManagerContractsStartAction extends Action {
  readonly type: PropertyManagerActionType.GetPropertyManagerContractsStart;
  readonly statusMessage: string;
}
export interface GetPropertyManagerContractsSuccessAction extends Action {
  readonly type: PropertyManagerActionType.GetPropertyManagerContractsSuccess;
  readonly statusMessage: string;
  readonly result: PageViewModel<ContractSimpleViewModel>;
}
export interface GetPropertyManagerContractsFailureAction extends Action {
  readonly type: PropertyManagerActionType;
  readonly errorMessage: string;
  readonly statusMessage: string;
}

/********** Search For A PM **********/
export interface SearchPropertyManagerStartAction extends Action {
  readonly type: PropertyManagerActionType.SearchPropertyManagerStart;
  readonly query: string | null;
}
export interface SearchPropertyManagerSuccessAction extends Action {
  readonly type: PropertyManagerActionType.SearchPropertyManagerSuccess;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly orderBy: string;
  readonly result: PageViewModel<PropertyManagerSearchViewModel>;
}
export interface SearchPropertyManagerFailureAction extends Action {
  readonly type: PropertyManagerActionType.SearchPropertyManagerFailure;
  readonly error: string;
}

// export interface PropertyManagerToggleViewOnlyAction extends Action {
//     readonly type: PropertyManagerActionType;
//     readonly propertyManager?: PropertyManagerViewModel;
//     readonly propertyManagementOffice?: PropertyManagementOfficeViewModel;
// }

/********** Create **********/
export const createPropertyManager = (
  propmgr: PropertyManagerViewModel,
  saveCallback?: Function,
  isModal?: boolean
) => {
  return async (dispatch: Dispatch<PropertyManagerState>) => {
    dispatch(createPropertyManagerStart());
    try {
      const id = await propertyManagementService.savePropertyManager(propmgr);
      if (saveCallback) {
        saveCallback(id);
        dispatch(actions.reset(FormNames.PropertyManagerForm));
        dispatch(createPropertyManagerSuccess(id, isModal));
      } else {
        dispatch(actions.reset(FormNames.PropertyManagerForm));
        dispatch(createPropertyManagerSuccess(id, isModal));
        //  if (propmgr.id === 0) {
        // dispatch(actions.reset('propertyManagerForm'));
        //  }
      }
    } catch (e) {
      dispatch(createPropertyManagerFailure(e.toString()));
    }
  };
};
export function createPropertyManagerStart(): PropertyManagerAction {
  return {
    type: PropertyManagerActionType.CreatePropertyManagerStart
  };
}
export function createPropertyManagerSuccess(id: number, isModal?: boolean): PropertyManagerAction {
  toast.success(
    <ToastComponent type={ToastType.Success} message={'Property Manager Created Successfully'} />,
    ToastOptions.Success
  );
  if (!isModal) {
    history.push(getRoute(RouteDefinitions.propertymanager.Details, { id: id }));
  }

  return {
    type: PropertyManagerActionType.CreatePropertyManagerSuccess,
    createdID: id
  };
}
export function createPropertyManagerFailure(message: string): PropertyManagerAction {
  toast.error(
    <ToastComponent type={ToastType.Error} message={'Network error, Unable to create property manager. ' + message} />,
    ToastOptions.Error
  );

  return {
    type: PropertyManagerActionType.CreatePropertyManagerFailure,
    errorMessage: message
  };
}

/********** Edit **********/
export function editPropertyManager(propmgr: PropertyManagerViewModel, saveCallback?: Function, isModal?: boolean) {
  return async (dispatch: Dispatch<PropertyManagerState>) => {
    dispatch(editPropertyManagerStart());
    propertyManagementService
      .savePropertyManager(propmgr)
      .then(id => {
        if (saveCallback) {
          saveCallback(id);
          dispatch(editPropertyManagerSuccess(id, isModal));
        } else {
          dispatch(editPropertyManagerSuccess(id, isModal));
        }
      })
      .catch(err => {
        dispatch(editPropertyManagerFailure(err.message));
      });
  };
}
export function editPropertyManagerStart(): PropertyManagerAction {
  return {
    type: PropertyManagerActionType.EditPropertyManagerStart
  };
}
export function editPropertyManagerSuccess(id: number, isModal?: boolean): PropertyManagerAction {
  toast.success(
    <ToastComponent type={ToastType.Success} message={'Property Manager Updated Successfully'} />,
    ToastOptions.Success
  );
  if (!isModal) {
    history.push(getRoute(RouteDefinitions.propertymanager.Details, { id: id }));
  }

  return {
    type: PropertyManagerActionType.EditPropertyManagerSuccess,
    createdID: id
  };
}
export function editPropertyManagerFailure(message: string): PropertyManagerAction {
  toast.error(
    <ToastComponent type={ToastType.Error} message={'Network error, Unable to update property manager. ' + message} />,
    ToastOptions.Error
  );

  return {
    type: PropertyManagerActionType.EditPropertyManagerFailure,
    errorMessage: message
  };
}

/********** Get **********/
export function getPropertyManager(id?: number, onSuccess?: Function) {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch(getPropertyManagerStart(id)); // tell the store that we're loading this, so we can make sure we don't reload the same one.
    // reset form
    dispatch(actions.reset('propertyManagerForm'));
    if (id) {
      propertyManagementService
        .getPropertyManagerDetails(id)
        .then(propertyManagerVM => {
          if (!propertyManagerVM) {
            return;
          }
          if (onSuccess) {
            let propertyManager = {
              ...propertyManagerVM,
              phone: propertyManagerVM.directPhone,
              officeId: propertyManagerVM.propMgmtOffice ? propertyManagerVM.propMgmtOffice!.id : null,
              officeName: propertyManagerVM.propMgmtOffice ? propertyManagerVM.propMgmtOffice!.value : null,
              city: propertyManagerVM.address && propertyManagerVM.address ? propertyManagerVM.address!.city : null
            } as PropertyManagerSearchViewModel;
            dispatch(onSuccess(propertyManager));
          } else {
            dispatch(getPropertyManagerSuccess(propertyManagerVM));
          }

          dispatch(actions.change('propertyManagerForm', propertyManagerVM));
        })
        .catch(err => {
          dispatch(getPropertyManagerFailure(err.message));
        });
    }
  };
}

export function getPropertyManagerStart(id?: number): PropertyManagerAction {
  return {
    type: PropertyManagerActionType.GetPropertyManagerStart,
    loadingPropertyManagerId: id
  };
}
export function getPropertyManagerSuccess(propmgr: PropertyManagerViewModel): GetPropertyManagerSuccessAction {
  return {
    type: PropertyManagerActionType.GetPropertyManagerSuccess,
    loadedPropertyManager: propmgr // ,
    // viewOnlypropertyManagementOffice: office
  };
}
export function getPropertyManagerFailure(message: string): PropertyManagerAction {
  toast.error(
    <ToastComponent type={ToastType.Error} message={'Network error, Unable to get property manager. ' + message} />,
    ToastOptions.Error
  );

  return {
    type: PropertyManagerActionType.GetPropertyManagerFailure,
    errorMessage: message
  };
}

/********** Get Details **********/
export function getPropertyManagerDetail(id: number) {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch(getPropertyManagerDetailStart());
    try {
      const propertyManagerVM = await propertyManagementService.getPropertyManagerDetails(id);
      dispatch(getPropertyManagerDetailSuccess(propertyManagerVM));
    } catch (e) {
      dispatch(getPropertyManagerDetailFailure(e.toString()));
    }
  };
}
export function getPropertyManagerDetailStart(): GetPropertyManagerDetailStartAction {
  // do something with the escrowofficer
  return {
    statusMessage: 'Getting Property Manager Detail',
    type: PropertyManagerActionType.GetPropertyManagerDetailStart
  };
}
export function getPropertyManagerDetailSuccess(
  propMgr: PropertyManagerViewModel
): GetPropertyManagerDetailSuccessAction {
  // do something with the escrowofficer
  return {
    type: PropertyManagerActionType.GetPropertyManagerDetailSuccess,
    propertyManagerVM: propMgr,
    statusMessage: 'Property Manager: ' + propMgr.id + 'loaded.'
  };
}
export function getPropertyManagerDetailFailure(err: string): GetPropertyManagerDetailFailureAction {
  return {
    type: PropertyManagerActionType.GetPropertyManagerDetailFailure,
    statusMessage: 'Failed to load PropertyManager.',
    errorMessage: err
  };
}

/********** Get Contract Via PM **********/
export function getContractsForManager(propMgrid: number) {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch(getContractsForManagerStart());
    try {
      const result: PageViewModel<ContractSimpleViewModel> = await contractService.getContractsByPropertyManagerId(
        propMgrid
      );
      dispatch(getContractsForManagerSuccess(result));
    } catch (e) {
      dispatch(getContractsForManagerFail(e.toString()));
    }
  };
}
export function getContractsForManagerStart(): GetPropertyManagerContractsStartAction {
  return {
    type: PropertyManagerActionType.GetPropertyManagerContractsStart,
    statusMessage: 'Getting the contract(s) for this Property Manager'
  };
}
export function getContractsForManagerSuccess(
  result: PageViewModel<ContractSimpleViewModel>
): GetPropertyManagerContractsSuccessAction {
  return {
    type: PropertyManagerActionType.GetPropertyManagerContractsSuccess,
    statusMessage: 'Got the contract(s) for this Property Manager',
    result: result
  };
}
export function getContractsForManagerFail(erroMessage: string): GetPropertyManagerContractsFailureAction {
  toast.error(
    <ToastComponent type={ToastType.Error} message={'Network error, Unable to get contracts for Property Manager'} />,
    ToastOptions.Error
  );

  return {
    type: PropertyManagerActionType.GetPropertyManagerContractsFailure,
    errorMessage: erroMessage,
    statusMessage: 'error'
  };
}

/********** Get PM Type **********/
export function getPropertyManagerTypes() {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch(getPropertyManagerTypesStart());
    try {
      const propertyManagers: Array<OptionsViewModel> = await propertyManagementService.getPropertyManagerTypes();
      dispatch(getPropertyManagerTypesSuccess(propertyManagers));
    } catch (e) {
      dispatch(getPropertyManagerTypesFailure(e.toString()));
    }
  };
}
export function getPropertyManagerTypesStart(): GetPropertyManagerTypesStartAction {
  return {
    type: PropertyManagerActionType.GetPropertyManagerTypesStart,
    message: 'Getting the Property Manager Types'
  };
}
export function getPropertyManagerTypesSuccess(
  propertyManagerTypes: Array<OptionsViewModel>
): GetPropertyManagerTypesSuccessAction {
  return {
    type: PropertyManagerActionType.GetPropertyManagerTypesSuccess,
    message: 'Got the property manager types',
    propertyManagerTypes: propertyManagerTypes
  };
}
export function getPropertyManagerTypesFailure(message: string): PropertyManagerAction {
  toast.error(
    <ToastComponent
      type={ToastType.Error}
      message={'Network error, Unable to get property manager types. ' + message}
    />,
    ToastOptions.Error
  );

  return {
    type: PropertyManagerActionType.GetPropertyManagerTypesFailure,
    errorMessage: message
  };
}

/********** Get PM Status **********/
export function getPropertyManagerStatuses() {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch(getPropertyManagerStatusesStart());
    try {
      const propertyManagers: Array<OptionsViewModel> = await propertyManagementService.getPropertyManagerStatuses();
      dispatch(getPropertyManagerStatusesSuccess(propertyManagers));
    } catch (e) {
      dispatch(getPropertyManagerStatusesFailure(e.toString()));
    }
  };
}
export function getPropertyManagerStatusesStart(): GetPropertyManagerStatusesStartAction {
  return {
    type: PropertyManagerActionType.GetPropertyManagerStatusesStart,
    message: 'Getting the Property Manager Statuses'
  };
}
export function getPropertyManagerStatusesSuccess(
  propertyManagerStatuses: Array<OptionsViewModel>
): GetPropertyManagerStatusesSuccessAction {
  return {
    type: PropertyManagerActionType.GetPropertyManagerStatusesSuccess,
    message: 'Got the property manager statuses',
    propertyManagerStatuses: propertyManagerStatuses
  };
}
export function getPropertyManagerStatusesFailure(message: string): GetPropertyManagerStatusesFailureAction {
  toast.error(
    <ToastComponent
      type={ToastType.Error}
      message={'Network error, Unable to get property manager statuses. ' + message}
    />,
    ToastOptions.Error
  );

  return {
    type: PropertyManagerActionType.GetPropertyManagerStatusesFailure,
    errorMessage: message
  };
}

/*** Search Property Manager  ***/
export function propertyManagerSearch(
  query: string | null,
  pageSize: number,
  pageNumber: number,
  orderBy: string,
  orderDirection: string
) {
  return async (dispatch: Dispatch<PropertyManagerSearchViewModel>) => {
    dispatch(searchPropertyManagerStart(query));
    try {
      let result: PageViewModel<
        PropertyManagerSearchViewModel
      > = await propertyManagementService.searchPropertyManagers(
        query,
        null,
        pageSize,
        pageNumber,
        orderBy,
        orderDirection
      );
      dispatch(searchPropertyManagerSuccess(pageNumber, pageSize, orderBy, result));
    } catch (e) {
      dispatch(searchPropertyManagerFailure(e.toString()));
    }
  };
}
export function searchPropertyManagerStart(query: string | null): SearchPropertyManagerStartAction {
  return {
    type: PropertyManagerActionType.SearchPropertyManagerStart,
    query: query
  };
}
export function searchPropertyManagerSuccess(
  pageNumber: number,
  pageSize: number,
  orderBy: string,
  result: PageViewModel<PropertyManagerSearchViewModel>
): SearchPropertyManagerSuccessAction {
  return {
    pageNumber: pageNumber,
    pageSize: pageSize,
    orderBy: orderBy,
    result: result,
    type: PropertyManagerActionType.SearchPropertyManagerSuccess
  };
}
export function searchPropertyManagerFailure(error: string): SearchPropertyManagerFailureAction {
  return {
    type: PropertyManagerActionType.SearchPropertyManagerFailure,
    error: error
  };
}

export function getPropertyManagerFromService(id: number) {
  return propertyManagementService.getPropertyManagerDetails(id);
}

export function lookupOffice(value: string, id: number | null) {
  return propertyManagementService.searchOffices(value, id);
}



// WEBPACK FOOTER //
// ./src/property-manager/property-manager.actions.tsx